<ng-container *ngIf="campagne?.id > 0">
  <div class="sub-menu">
    <div class="sub-menu--content">
      <div class="sub-menu--content--line">{{campagne.libelle}}</div>
      <div class="sub-menu--content--line">{{displaySubscriptionsDate(campagne)}}</div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="displayClosedMessage()">
  <neo-message [messageType]="messageType.warning" [message]="displayClosedMessage()"></neo-message>
</ng-container>
<ng-container *ngIf="!noResults">
  <ng-container *ngIf="activityDetail?.id === 0">
    <mat-drawer-container class="drawer" [hasBackdrop]="true" autosize>
      <mat-drawer #drawer [mode]="'over'" >
        <app-filter-pan *ngIf="drawer.opened" [className]="mainStyle.themeName" [filters]="filters" [drawer]="drawer" (sendFilters)="setFilters($event)"></app-filter-pan>
      </mat-drawer>
      <mat-drawer-content>
        <app-activities-menu [police]="police" [interlignage]="interlignage" [mainStyle]="mainStyle" [menuItems]="menuItems" (myActivities)="getActivities($event)" (displayFilters)="drawer.toggle()"></app-activities-menu>
        <mat-card appearance="outlined" class="main-card">
          <ng-container *ngIf="activities.length > 0">
            <app-paginator *ngIf="!myActivities" [pagination]="pagination" (paginate)="paginate($event)"></app-paginator>
            <div class="activities">
              <app-activity *ngFor="let activity of activities" [connecte]="connecte" [activity]="activity" (openDetail)="openDetail($event)"></app-activity>
            </div>
            <app-paginator *ngIf="!myActivities" [pagination]="pagination" (paginate)="paginate($event)"></app-paginator>
          </ng-container>
          <ng-container *ngIf="noResults || noFilteredResults">
            <span class="nothing">{{nothingMessage}}</span>
          </ng-container>
        </mat-card>
      </mat-drawer-content>
    </mat-drawer-container>
  </ng-container>

  <ng-container *ngIf="activityDetail?.id > 0">
    <mat-card appearance="outlined" class="main-card">
      <app-activity-detail [activity]="activityDetail" [connecte]="connecte" [campagne]="campagne" (goList)="closeDetail()"></app-activity-detail>
    </mat-card>
  </ng-container>
</ng-container>
<ng-container *ngIf="noResults">
  <app-activities-menu [police]="police" [interlignage]="interlignage" [mainStyle]="mainStyle" [menuItems]="menuItems" (myActivities)="getActivities($event)"></app-activities-menu>
  <mat-card appearance="outlined" class="main-card">
    <span class="nothing">{{nothingMessage}}</span>
  </mat-card>
</ng-container>
